import { map } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { Command, CommandBase, MultiselectCommand } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { ControlDataExportCommand } from '../../../rent/command/control-data-export.command';
import { ControlDataFormService } from '../../../rent/service/data/control-data-form.service';
import { NativeWindowService } from '../../../core/service/native-window.service';
import { CooperativeHousingTransferFormService } from '../../../rent/service/data/cooperative-housing-transfer-form.service';
import { transferCommand } from '../../../rent/command/transfer.command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { CooperativeHousingTransferUpdateFormComponent } from '../../../rent/component/cooperative-housing-transfer-update-form/cooperative-housing-transfer-update-form.component';

@Injectable()
export class UpdateTransferCommandHandler implements ICommandHandler {
  constructor(
    private _service: CooperativeHousingTransferFormService,
    private _nativeWindow: NativeWindowService,
    private _injector: Injector,
    private _actionService: ActionWindowService
  ) {}

  private items: any;

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === transferCommand.updateTransfer && command.context;
    }
    if (command instanceof MultiselectCommand) return command.id === transferCommand.updateTransfer && command.itemsSource.length > 0;

    return false;
  }
  execute(command: CommandBase): Observable<boolean> {    
    if (command instanceof Command) {
      if (command.id === transferCommand.updateTransfer) {
        this._actionService.open(CooperativeHousingTransferUpdateFormComponent, this._injector, null, command.context.id, false).pipe(
          map(res => {
            if (res) {
              return true;
            }
            return false;
          })
        );
      }
      return;
    }

    if (command instanceof MultiselectCommand) {
      if (command.id === transferCommand.updateTransfer) {
        this.items = command.items.map(item => item.id);
        return this._actionService.open(CooperativeHousingTransferUpdateFormComponent, this._injector, null, this.items, false).pipe(
          map(res => {
            if (res) {
              return true;
            }
            return false;
          })
        );
      }

      return;
    }
  }
}
